import { customAxios, IDUSUARIO, FDV_URL, STOCK_URL, GENERIC_URL } from '../constants';
import {
  FETCH_ESTADO_PEDIDO,
  FETCH_ESTADO_CANCELACION,
  FETCH_ESTADO_GENERAL_PLANIF,
  FETCH_ESTADO_GENERAL_TRANSP,
  FETCH_ESTADO_GENERAL_TIPOPLACA,
  FETCH_ESTADO_GENERAL_TIPOENTREGA,
  FETCH_ESTADO_GENERAL_LUGARENTREGA,
  FETCH_ESTADO_GENERAL_MOTIVORECHAZO,
  FETCH_ESTADOS
} from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchEstados() {
  const request = customAxios.get(`${FDV_URL}/maestro/ficha-venta/estados-ficha-venta`)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_ESTADOS,
    payload: request,
  };
}

export function fetchEstadoPedido(params) {
  const config = {
    params: params,
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const request = customAxios.get(`${STOCK_URL}/maestros/estados-pedidos`, config)

  return {
    type: FETCH_ESTADO_PEDIDO,
    payload: request,
  };
}

export function fetchEstadoCancelacion() {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const request = customAxios.get(`${STOCK_URL}/maestros/estados-cancelacion`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_ESTADO_CANCELACION,
    payload: request,
  };
}

export function fetchEstadoGeneralPlanif() {
  const config = {
    params: {
      codGrupo: 31,
    },

    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const request = customAxios.get(`${GENERIC_URL}/logistica/maestro/listardatos`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_ESTADO_GENERAL_PLANIF,
    payload: request,
  };
}

export function fetchEstadoGeneralTransp() {
  const config = {
    params: {
      codGrupo: 32,
    },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const request = customAxios.get(`${GENERIC_URL}/logistica/maestro/listardatos`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_ESTADO_GENERAL_TRANSP,
    payload: request,
  };
}

export function fetchEstadoGeneralLugarEntrega() {
  const config = {
    params: {
      codGrupo: 35,
    },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const request = customAxios.get(`${GENERIC_URL}/logistica/maestro/listardatos`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_ESTADO_GENERAL_LUGARENTREGA,
    payload: request,
  };
}

export function fetchEstadoGeneralTipoPlaca() {
  const config = {
    params: {
      codGrupo: 33,
    },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const request = customAxios.get(`${GENERIC_URL}/logistica/maestro/listardatos`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_ESTADO_GENERAL_TIPOPLACA,
    payload: request,
  };
}

export function fetchEstadoGeneralTipoEntrega() {
  const config = {
    params: {
      codGrupo: 34,
    },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const request = customAxios.get(`${GENERIC_URL}/logistica/maestro/listardatos`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_ESTADO_GENERAL_TIPOENTREGA,
    payload: request,
  };
}

export function fetchEstadoGeneralMotivoRechazo() {
  const config = {
    params: {
      codGrupo: 36,
    },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const request = customAxios.get(`${GENERIC_URL}/logistica/maestro/listardatos`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_ESTADO_GENERAL_MOTIVORECHAZO,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/Estados.js